import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { ShareObjectsImplementation } from '@commoncore/implementation/ShareObjectsImplementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';
import { Controller } from './Controller';

export class ShareObjectsController extends Controller{
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    shareObjectsImplementation: any;
    loggerService: any;
    cleverTapEventsService: any;
    listImpl:any;
    listService:any;
    localStorageService:any;
    fileOperationsImplementation:any;
  dcGroupCodePicker: any;
    public constructor(public globalService:GlobalService) {
      super(globalService)
      this.shareObjectsImplementation = ShareObjectsImplementation.getInstance(this.globalService)
    }
    
    public static getInstance(globalService):ShareObjectsController{
		if(this.singleInstance == null){
			this.singleInstance = new ShareObjectsController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
      this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.fileOpsController = FileOperationsController.getInstance(globalService);
      this.listImpl = ListViewImplementation.getInstance(globalService);
      this.listService = globalService.getListServiceRef();
      this.localStorageService = globalService.getLocalStorageSvcRef();
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
      this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    }


   async  createShareLinkForSelectedObjects(files){ 
       var url, albumKey;
       this.shareObjectsImplementation.albumFiles = await this.checkIfAlbumFiles(files)
       if(this.shareObjectsImplementation.albumFiles){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumShareLink"]
       }else{
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["getShareLink"]
       }
       this.shareObjectsImplementation.setHandler(this.globalService)
       var payload = this.shareObjectsImplementation.setPayLoadForCreatingShareLink(files)
      try{
        if(this.shareObjectsImplementation.albumFiles){
          albumKey = this.universalService.currentAlbum?this.universalService.currentAlbum["boardKey"]:files[0]["boardKey"]
        }
        var result = await this.shareObjectsImplementation.createShareLink(url,payload,this.shareObjectsImplementation.albumFiles,albumKey);
        return result;
      }catch(exc){
        this.loggerService.log("exception handled for creating share link",exc);
        return null;
      }
    }


    async shareLinkToRecipients(mailIds,shareKey){
      var url;
      if(this.shareObjectsImplementation.albumFiles){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["sendAlbumShareLink"]
      } else if(this.universalService.showEnhancedShareLink == true) {
        if(this.universalService.currentTeamFolder ){
          this.cleverTapEventsService.tfPublicShare();
        }
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["sendUniversalShareLink"]
      } else{
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["sendShareLink"]
      }
      try{
          var resp = await this.shareObjectsImplementation.sendEmail(url,mailIds,shareKey);
          this.loggerService.log("response after sending email",resp)
          return resp;
      }catch(exc){
          this.loggerService.log("exception in sending email",exc);
      }
    }


  async createCollabShareLinkForSelectedObjects(files) {
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"]
    if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.selectedFile["tfKey"] || this.router.url.includes("/search/tf")) {
      //As per ticket - 550679
      var tfKey = this.universalService.selectedFile["tfKey"]?this.universalService.selectedFile["tfKey"]:this.universalService.currentTeamFolder["tfKey"];
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "?tfKey=" + tfKey;
      this.cleverTapEventsService.tfPrivateShare();
    }
    //url = this.universalService.currentTeamFolder ? url + '?tfKey=' + this.universalService.currentTeamFolder["tfKey"] : url;
    this.shareObjectsImplementation.setHandler(this.globalService)
    var payload = this.shareObjectsImplementation.setPayLoadForCreatingCollabShareLink(files)

    try {
      var result = await this.shareObjectsImplementation.createCollabShareLink(url, payload);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for creating share link", exc);
      return exc;
    }
  }


  async updateCollabShareForSelectedObjects() {
    await this.dcGroupCodePicker.decideTypeOfShare(this.universalService.selectedFile['shareKey']) 
    var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"];
    if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.selectedFile["tfKey"]) {
      //As per ticket - 550679
      var tfKey = this.universalService.selectedFile["tfKey"]?this.universalService.selectedFile["tfKey"]:this.universalService.currentTeamFolder["tfKey"];
      url = SHARE_DC["DC_URLS"]["nmsURL"]  + ENV_CONFIG.commonUrls["nmsCollabShare"] + "?tfKey=" + tfKey;
    }
    this.shareObjectsImplementation.setHandler(this.globalService)
    var payload = this.shareObjectsImplementation.setPayLoadForUpdatingCollabShareLink()
    var newData = [];
    try { 
      var result = await this.shareObjectsImplementation.updateCollabShareLink(url, payload);
      if(!result.isShared && this.router.url.includes("/sharedbyme")){
        var indexArray = this.listImpl.rowData;
        indexArray.map(idx=>{
          if(idx.objectId == payload.objectKey){
            newData.push(idx)
          }
        })
        var res = this.listService.listOptions.api.applyTransaction({ remove: newData })
      }
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for creating share link", exc);
      return exc;
    }
  }

    /**
   * Get members' list with whom file is shared
   */
    async getSharedFileMembers(shareKey) {
     
      if(window.location.href.indexOf("sharedbyme") > -1 ){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + shareKey + "/members";
      }else{
        await this.dcGroupCodePicker.decideTypeOfShare(shareKey);
        var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + shareKey + "/members";
      }
      if(window.location.href.indexOf("teamfolder") > -1 || (this.universalService.selectedFile && this.universalService.selectedFile["tfKey"])) {
        //As per ticket - 550679
        var tfKey = this.universalService.selectedFile["tfKey"]?this.universalService.selectedFile["tfKey"]:this.universalService.currentTeamFolder["tfKey"];
        var objectKey = this.universalService.selectedFile["objectKey"];

        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + shareKey + "/members?tfKey=" + tfKey + "&objectKey=" + objectKey;
      }
      this.shareObjectsImplementation.setHandler(this.globalService);
      try {
        var result = await this.shareObjectsImplementation.getSharedFileMembers(url);
        return result;
      } catch (exc) {
        this.loggerService.log("exception handled for creating share link", exc);
        return null;
      }
    }

  

  async getSuggestedContacts(searchKey) {

    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["contactsURL"] + ENV_CONFIG.commonUrls["amikoCabSearch"] + "?displayName=" + searchKey + "&isgeneric=true";
    this.shareObjectsImplementation.setHandler(this.globalService)

    try {
      var result = await this.shareObjectsImplementation.getUserContactsBySearchKey(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for contacts", exc);
      return null;
    }
  }
    checkIfAlbumFiles(files){
      const isAlbumFile = files.some(obj=> {
        var type = obj["FullObject"]?obj["FullObject"]["objectType"]:obj["objectType"];
        return (type != "FE" && type != "FR"); 
      })
      return isAlbumFile;
    }

    async createInviteLink(){
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["inviteLink"] + this.universalService.currentAlbum["boardKey"];
      this.shareObjectsImplementation.setHandler(this.globalService);
      try{
        var result = await this.shareObjectsImplementation.getInviteLink(url);
        return result;
      } catch(exc){
        console.log("error in invite flow",exc);
      }
    }

    async InviteFriendsToJoinAlbum(mailIds){
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumInvite"] + this.shareObjectsImplementation.inviteResp["inviteCode"] + ENV_CONFIG.commonUrls["shareInvite"];
      this.shareObjectsImplementation.setHandler(this.globalService);
      try{
        var result = await this.shareObjectsImplementation.shareInviteLink(url,mailIds);
        return result
      } catch(exc){
        console.log("error in invite flow",exc);
      }
    }

    /**
     * Universal Share link code
     */

    async getUniversalShareLinkForSelectedObjects(files) {
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["enhancedShareLink"];
      url = this.universalService.currentTeamFolder ? url + '?tfKey=' + this.universalService.currentTeamFolder["tfKey"] : url;
      if(this.universalService.currentTeamFolder ){
        this.cleverTapEventsService.tfPublicShare();
      }
      this.shareObjectsImplementation.setHandler(this.globalService)
      var payload = this.shareObjectsImplementation.setPayLoadForUniversalShareLink(files);
      try {
        var result = await this.shareObjectsImplementation.createUniversalShareLink(url, payload);
        return result;
      } catch (exc) {
        console.log("exception handled for creating universal share link:", exc);
        return exc;
      }
    }

    async updateUniversalShareLink() {
      var shareUrl = this.shareObjectsImplementation.universalShareUrl.split('?u=')[1];
      if(shareUrl == undefined || shareUrl == "") {
        return;
      }
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["enhancedShareLink"] + "/" + shareUrl;
      this.shareObjectsImplementation.setHandler(this.globalService)
      var payload = this.shareObjectsImplementation.setPayLoadForUpdateUniversalShareLink();
      try {
        var result = await this.shareObjectsImplementation.updateUniversalShareLink(url, payload);
        return result;
      } catch (exc) {
        console.log("exception handled for creating universal share link:", exc);
        return exc;
      }
    }


    async getUniversalShareLinkPassword(shareKey) {
     var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["enhancedShareLink"] + "/passpharse/" + shareKey;
     this.shareObjectsImplementation.setHandler(this.globalService)
     try {
       var result = await this.shareObjectsImplementation.getUniversalShareLinkPassword(url);
       return result;
     } catch (exc) {
       console.log("exception handled for creating universal share link:", exc);
       return exc;
     }
   }
    /**
     * Universal Share link code - end
     */

}